module.exports = __webpack_public_path__ + "static/img/11.0408e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/11.png
// module id = ju0b
// module chunks = 0